<template>
  <div class="collection">
    <div class="collection-header">
      <p class="collection-title">{{ Translator('soprasolar.claim_request.step1.form.product.title', {number: index + 1}) }}</p>
      <button type="button" @click="onDelete" class="collection-button">
        <i class="ic ic-trash"></i>
        {{ Translator('soprasolar.claim_request.step1.form.product.delete_button') }}
      </button>
    </div>

    <div class="form-row">
      <div class="form-group" style="width: 130px; flex-shrink: 0;">
        <div class="form-label-container">
          <label :for="'reference-' + index" class="control-label required">
            {{ Translator('soprasolar.claim_request.step1.form.product.reference') }}
          </label>
        </div>
        <input type="text" :id="'reference-' + index" class="form-control" v-model="form.reference" required>
      </div>
      <div class="form-group">
        <div class="form-label-container">
          <label :for="'name-' + index" class="control-label required">
            {{ Translator('soprasolar.claim_request.step1.form.product.name') }}
          </label>
        </div>
        <input type="text" :id="'name-' + index" class="form-control" v-model="form.name" required>
      </div>
      <div class="form-group" style="width: 90px; flex-shrink: 0;">
        <div class="form-label-container">
          <label :for="'quantity-' + index" class="control-label required">
            {{ Translator('soprasolar.claim_request.step1.form.product.quantity') }}
          </label>
        </div>
        <input type="number" :id="'quantity-' + index" class="form-control" @change="onUpdateQuantity()" @keyup="onUpdateQuantity()" v-model="form.quantity" required min="0">
      </div>
    </div>

    <template v-if="parseInt(form.quantity) > 0">
      <!-- <p v-if="hasAlreadyPhotovoltaic" class="informations">
        <i class="ic ic-info" aria-hidden="true"></i>
        Vous avez déjà un article photovoltaïque dans votre réclamation.
      </p> -->
      <template v-if="!hasAlreadyPhotovoltaic">
        <div class="checkbox form-group">
          <input type="checkbox" :id="'is_photovoltaic-' + index" v-model="form.isPhotovoltaic" @change="onChange()">
          <label :for="'is_photovoltaic-' + index" class="control-label">
            {{ Translator('soprasolar.claim_request.step1.form.product.is_photovoltaic') }}
          </label>
        </div>

        <div class="form-group" v-if="form.isPhotovoltaic">
          <div class="form-label-container">
            <label for="product-reference-0" class="control-label">
              {{ Translator('soprasolar.claim_request.step1.form.product.serial_number') }}
            </label>
          </div>
          <div v-for="(reference, index) in this.form.references" :key="index" style="margin-top: 10px;">
            <input type="text" :id="'product-reference-' + index" class="form-control" v-model="form.references[index]">
          </div>
        </div>
      </template>
    </template>
  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-claim/assets/styles/import";
  .informations {
    font-style: italic;
    font-size: rem(14);
    .ic {
      font-size: rem(18);
    }
  }
  .collection {
    margin-bottom: rem(10);
    background-color: $grey-ulight;
    border-left: rem(2) solid $color-main;
    padding: rem(15) rem(20) rem(15) rem(15);
    .collection-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: rem(15);
    }
    .collection-title {
      font-weight: bold;
      font-size: rem(16);
      color: $color-second;
    }
    .collection-actions {
      display: flex;
      justify-content: flex-end;
    }
    .collection-button {
      @include resetBtn;
      display: inline-block;
      color: $color-main;
      font-size: rem(14);
      .ic {
        vertical-align: middle;
        margin-right: rem(5);
        font-size: rem(22);
      }
    }
  }
</style>
<script>
import AppControlService from '@/soprasolar-claim/services/AppControl';

export default {
  props: ['form', 'products', 'index'],
  name: 'form-product',
  components: {},
  data () {
    return {
      hasAlreadyPhotovoltaic: false,
      datas: AppControlService.datas,
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
    AppControlService.on('photovoltaic', this._onUpdatePhotovoltaic);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
    AppControlService.off('photovoltaic', this._onUpdatePhotovoltaic);
  },

  mounted() {
    this.onUpdateQuantity();
    if(this.form.isPhotovoltaic) {
      AppControlService.defineHasPhotovoltaic( this.form, this.form.isPhotovoltaic );
    }
  },

  methods: {
    onChange() {
      const quantity = parseInt(this.form.quantity);
      if( isNaN(quantity) ) {
        this.form.isPhotovoltaic = false;
        this.form.references = null;
      } else {
        this.form.references = this.form.isPhotovoltaic ? Array.from(Array(quantity).keys(), () => null) : null;
      }
      this.$forceUpdate();
      AppControlService.defineHasPhotovoltaic( this.form, this.form.isPhotovoltaic );
    },

    onUpdateQuantity() {
      this.$forceUpdate();
      this._onUpdatePhotovoltaic();

      if(!this.form.isPhotovoltaic) return;
      const quantity = parseInt(this.form.quantity);
      if( isNaN(quantity) ) return;
      if( quantity > this.form.references.length ) {
        const newKeys = Array.from(Array(quantity - this.form.references.length).keys(), () => null);
        this.form.references = [
          ...this.form.references,
          ...newKeys
        ]
      } else if( quantity < this.form.references.length ) {
        for( let i = this.form.references.length - 1; i > 0; i--) {
          if( i >= quantity ) this.form.references.splice(i, 1);
        }
      }
      this.$forceUpdate();
    },

    onDelete() {
      if(AppControlService.formPhotovoltaic === this.form) AppControlService.defineHasPhotovoltaic( this.form, false );

      this.products.splice(this.index, 1);
      this.$emit('update');
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdatePhotovoltaic() {
      this.hasAlreadyPhotovoltaic = !!AppControlService.formPhotovoltaic && AppControlService.formPhotovoltaic !== this.form
     },

    _onUpdateDatas(datas) {
      this.datas = datas;
    }
  }
};
</script>